import React, { ReactNode, useEffect, useState } from 'react';

import { PartyInvolved } from '@totem/components/ticketing/ticketing';
import NaPartyInvolvedContext from '@totem/components/unauthenticated/ticketing/details/partyInvolved/naPartyInvolvedContext';
import { UNAUTHENTICATED_TICKET_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  token: string;
  children?: ReactNode;
};

const NAPartyInvolvedContainer = ({ token, children }: Props) => {
  const [partyInvolvedData, setPartyInvolvedData] =
    useState<PartyInvolved>(null);

  useEffect(() => {
    fetch(`${UNAUTHENTICATED_TICKET_ENDPOINT}/partyInvolved`, {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
      }),
    })
      .then((res) => res.json())
      .then((result: PartyInvolved) => {
        setPartyInvolvedData(result);
      });
  }, [token]);

  return (
    <NaPartyInvolvedContext.Provider
      value={{
        partyInvolved: partyInvolvedData,
        token,
      }}
    >
      {children}
    </NaPartyInvolvedContext.Provider>
  );
};

export default NAPartyInvolvedContainer;
